module.exports = __webpack_public_path__ + "img/mobile/Menus-betmenu/stepper_down_purple@3x.png?1.0.24";


//////////////////
// WEBPACK FOOTER
// ./out/img/mobile/Menus-betmenu/stepper_down_purple@3x.png
// module id = 664
// module chunks = 0